import { render, staticRenderFns } from "./TurnoverPerUserCurrentYearInformation.vue?vue&type=template&id=6b1c2512&"
import script from "./TurnoverPerUserCurrentYearInformation.vue?vue&type=script&lang=ts&"
export * from "./TurnoverPerUserCurrentYearInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports